import { localizedErrors } from './error-copy';
import { text, type Locale } from '../shared/content';
const words = {
  visibility: text('Who can read this', '谁可以看到', '誰可以看到', 'Quién puede leer esto'),
  postActions: text('Post actions', '帖子操作', '貼文操作', 'Acciones de publicación'),
  cancelWork: text('End this shift', '结束当前工作', '結束目前工作', 'Finalizar este turno'),
  tagline: text(
    'A little city. A life of your own.',
    '一座小小的城市，一段自己的生活。',
    '一座小小的城市，一段自己的生活。',
    'Una pequeña ciudad. Una vida a tu manera.',
  ),
  newYork: text('NEW YORK CHAPTER', '纽约篇章', '紐約篇章', 'CAPÍTULO NUEVA YORK'),
  hello: text(
    'Make yourself at home.',
    '在这里，慢慢安顿下来。',
    '在這裡，慢慢安頓下來。',
    'Siéntete como en casa.',
  ),
  start: text('Start your story', '开始你的故事', '開始你的故事', 'Comienza tu historia'),
  continue: text('Welcome back', '欢迎回来', '歡迎回來', 'Te damos la bienvenida'),
  signIn: text('Sign in', '登录', '登入', 'Iniciar sesión'),
  signUp: text('Create account', '创建账号', '建立帳號', 'Crear cuenta'),
  email: text('Email address', '邮箱地址', '電子郵件', 'Correo electrónico'),
  password: text(
    'Password · 10+ characters',
    '密码 · 至少 10 位',
    '密碼 · 至少 10 位',
    'Contraseña · 10+ caracteres',
  ),
  name: text('What should we call you?', '怎么称呼你？', '怎麼稱呼你？', '¿Cómo te llamas?'),
  already: text(
    'Already have a story here? Sign in',
    '已经有账号？登录',
    '已經有帳號？登入',
    '¿Ya tienes una historia? Inicia sesión',
  ),
  newHere: text(
    'New to the neighborhood? Create account',
    '刚到这个街区？创建账号',
    '剛到這個街區？建立帳號',
    '¿Eres nuevo? Crea una cuenta',
  ),
  begin: text('Find your New York', '开始纽约生活', '開始紐約生活', 'Descubre tu Nueva York'),
  graduate: text('A fresh start', '初来乍到', '初來乍到', 'Un nuevo comienzo'),
  switcher: text('A new direction', '转个方向', '轉個方向', 'Un nuevo rumbo'),
  founder: text('A small business dream', '小店梦想家', '小店夢想家', 'Un sueño emprendedor'),
  background: text(
    'Everyone starts somewhere. What brings you here?',
    '每个人都有起点。你为何来到这里？',
    '每個人都有起點。你為何來到這裡？',
    'Todo el mundo empieza en algún lugar. ¿Qué te trae aquí?',
  ),
  settlement: text(
    'C$100 cash + C$400 home vouchers. Your basic room is always free.',
    'C$100 现金 + C$400 家居券。基础房间永久免费。',
    'C$100 現金 + C$400 家居券。基礎房間永久免費。',
    'C$100 + C$400 en vales de hogar. Tu habitación básica siempre es gratis.',
  ),
  map: text('Neighborhood', '街区', '街區', 'Barrio'),
  home: text('My home', '我的家', '我的家', 'Mi hogar'),
  careers: text('Work & skills', '工作与技能', '工作與技能', 'Trabajo y habilidades'),
  goals: text('Your next chapter', '下一段故事', '下一段故事', 'Tu siguiente capítulo'),
  shops: text('Local cafés', '街区咖啡店', '街區咖啡店', 'Cafeterías'),
  feed: text('City journal', '城市动态', '城市動態', 'Diario de la ciudad'),
  chat: text('Nearby chat', '附近聊天', '附近聊天', 'Chat cercano'),
  city: text('Our city', '我们的城市', '我們的城市', 'Nuestra ciudad'),
  settings: text('Settings', '设置', '設定', 'Ajustes'),
  cash: text('Cash', '现金', '現金', 'Efectivo'),
  vouchers: text('Home vouchers', '家居券', '家居券', 'Vales de hogar'),
  energy: text('Energy', '精力', '精力', 'Energía'),
  hunger: text('Fullness', '饱腹', '飽足', 'Saciedad'),
  go: text('Let’s go', '前往这里', '前往這裡', 'Vamos'),
  here: text('You are here', '你在这里', '你在這裡', 'Estás aquí'),
  traveling: text('On your way…', '正在前往…', '正在前往…', 'De camino…'),
  tap: text(
    'Choose a place to start your day',
    '选一个地点，开始今天的生活',
    '選一個地點，開始今天的生活',
    'Elige un lugar para empezar el día',
  ),
  close: text('Close', '关闭', '關閉', 'Cerrar'),
  loading: text('Just a moment…', '请稍等…', '請稍等…', 'Un momento…'),
  save: text('Save changes', '保存修改', '儲存變更', 'Guardar cambios'),
  saved: text('All set.', '完成了。', '完成了。', 'Listo.'),
  error: text(
    'Unable to connect. Your progress is saved on the server. Try again.',
    '暂时无法连接。进度保存在服务器，请重试。',
    '暫時無法連線。進度保存在伺服器，請重試。',
    'No se pudo conectar. Tu progreso está guardado. Inténtalo de nuevo.',
  ),
  level: text('Level', '等级', '等級', 'Nivel'),
  xp: text('experience', '经验', '經驗', 'experiencia'),
  shift: text('Start a shift', '开始工作', '開始工作', 'Empezar un turno'),
  finish: text('Collect your paycheck', '领取工资', '領取薪水', 'Cobrar tu sueldo'),
  working: text('Making things happen', '认真工作中', '認真工作中', 'Manos a la obra'),
  shiftInfo: text(
    '45 seconds · 3 paid shifts per UTC day, including NPC orders',
    '45 秒 · 每个 UTC 日共 3 次带薪额度（含 NPC 订单）',
    '45 秒 · 每個 UTC 日共 3 次帶薪額度（含 NPC 訂單）',
    '45 segundos · 3 turnos diarios UTC, incluidos pedidos NPC',
  ),
  choose: text('Choose your approach', '选择你的工作方式', '選擇你的工作方式', 'Elige cómo hacerlo'),
  earned: text('Paycheck received', '工资已到账', '薪水已入帳', 'Sueldo recibido'),
  talk: text('Say hello', '打个招呼', '打個招呼', 'Saludar'),
  npc: text('Neighborhood NPC', '街区 NPC', '街區 NPC', 'NPC del barrio'),
  relationship: text('Familiarity', '熟悉度', '熟悉度', 'Confianza'),
  room: text('A room of your own', '属于自己的小屋', '屬於自己的小屋', 'Un espacio propio'),
  furniture: text('Make it yours', '挑选家居', '挑選家居', 'Dale tu estilo'),
  owned: text('Owned', '已拥有', '已擁有', 'En propiedad'),
  buy: text('Bring it home', '带回家', '帶回家', 'Llévatelo a casa'),
  place: text('Place in room', '放入房间', '放入房間', 'Colocar'),
  selectSpot: text(
    'Choose a free spot in the room',
    '选择房间内的空位',
    '選擇房間內的空位',
    'Elige un espacio libre',
  ),
  placed: text('In your room', '已摆放', '已擺放', 'En tu habitación'),
  upgrade: text('Upgrade home', '升级住房', '升級住房', 'Mejorar hogar'),
  voucherNote: text(
    'Home vouchers are spent first on furniture. They cannot be traded.',
    '购买家具会优先使用家居券；家居券不可交易。',
    '購買家具會優先使用家居券；家居券不可交易。',
    'Los vales se usan primero para muebles. No se pueden transferir.',
  ),
  claim: text(
    'Collect C$25 starter grant',
    '领取 C$25 安家补助',
    '領取 C$25 安家補助',
    'Recoger C$25 de ayuda inicial',
  ),
  completed: text('Chapter complete', '已完成', '已完成', 'Capítulo completado'),
  progress: text('Your story so far', '你的故事正在发生', '你的故事正在發生', 'Tu historia hasta ahora'),
  openShop: text('Open your little café', '开一家小咖啡店', '開一家小咖啡店', 'Abre tu cafetería'),
  shopCost: text(
    'C$250 · includes 10 servings · visit Corner & Co. to begin',
    'C$250 · 含 10 份库存 · 前往街角咖啡馆开店',
    'C$250 · 含 10 份庫存 · 前往街角咖啡館開店',
    'C$250 · incluye 10 raciones · empieza en Corner & Co.',
  ),
  shopName: text('Your café’s name', '咖啡店名称', '咖啡店名稱', 'Nombre de tu cafetería'),
  open: text('Open café · C$250', '开店 · C$250', '開店 · C$250', 'Abrir · C$250'),
  stock: text('Servings left', '剩余库存', '剩餘庫存', 'Raciones disponibles'),
  sold: text('Served', '已售', '已售', 'Servidos'),
  price: text('Price per serving', '每份价格', '每份價格', 'Precio por ración'),
  restock: text('Add 10 servings · C$60', '补货 10 份 · C$60', '補貨 10 份 · C$60', 'Reponer 10 · C$60'),
  npcOrders: text(
    'Fulfill today’s NPC orders',
    '完成今日 NPC 订单',
    '完成今日 NPC 訂單',
    'Atender pedidos NPC de hoy',
  ),
  npcDemand: text(
    'NPC demand: C$12 → 12, C$18 → 8, C$24 → 5 servings daily. Uses one paid allowance, once per UTC day. Supplies cost C$6 each; tax applies. No offline restocking.',
    '每日 NPC 需求：C$12 售 12 份，C$18 售 8 份，C$24 售 5 份。每个 UTC 日仅一批，占一次带薪额度；每份补货成本 C$6，销售扣税，离线不自动补货。',
    '每日 NPC 需求：C$12 售 12 份，C$18 售 8 份，C$24 售 5 份。每個 UTC 日僅一批，占一次帶薪額度；每份補貨成本 C$6，銷售扣稅，離線不自動補貨。',
    'Demanda NPC diaria: C$12 → 12, C$18 → 8, C$24 → 5. Un lote por día UTC, usa un turno. Reposición: C$6 por unidad, más impuestos de venta. Sin reposición automática.',
  ),
  emptyShops: text(
    'The next neighborhood favorite could be yours.',
    '街区下一家人气小店，也许就属于你。',
    '街區下一家人氣小店，也許就屬於你。',
    'La próxima favorita del barrio podría ser la tuya.',
  ),
  order: text('Order a coffee', '买一杯咖啡', '買一杯咖啡', 'Pedir un café'),
  shareThought: text(
    'A small moment from your New York…',
    '分享一个纽约生活的小瞬间…',
    '分享一個紐約生活的小瞬間…',
    'Un pequeño momento de tu Nueva York…',
  ),
  publish: text('Post to the city', '发布动态', '發布動態', 'Publicar'),
  send: text('Send', '发送', '傳送', 'Enviar'),
  emptyFeed: text(
    'A new city, a blank page. Share the first little moment.',
    '新城市，空白的一页。记录第一个生活瞬间吧。',
    '新城市，空白的一頁。記錄第一個生活瞬間吧。',
    'Una ciudad nueva, una página en blanco. Comparte el primer momento.',
  ),
  original: text('Show original', '查看原文', '查看原文', 'Ver original'),
  translated: text('Automatically translated', '自动翻译', '自動翻譯', 'Traducción automática'),
  translatePending: text('Translating…', '正在翻译…', '正在翻譯…', 'Traduciendo…'),
  translationUnavailable: text(
    'Translation unavailable · original shown',
    '翻译暂不可用 · 已显示原文',
    '翻譯暫不可用 · 已顯示原文',
    'Traducción no disponible · texto original',
  ),
  friendsOnly: text('Friends only', '仅好友', '僅好友', 'Solo amigos'),
  everyone: text('City residents', '城市居民', '城市居民', 'Residentes'),
  like: text('Like', '喜欢', '喜歡', 'Me gusta'),
  delete: text('Delete', '删除', '刪除', 'Eliminar'),
  report: text('Report', '举报', '檢舉', 'Denunciar'),
  block: text('Block author', '屏蔽作者', '封鎖作者', 'Bloquear autor'),
  addFriend: text('Add friend', '添加好友', '新增好友', 'Añadir amigo'),
  community: text('A greener riverfront', '让河岸更绿一点', '讓河岸更綠一點', 'Una ribera más verde'),
  communityInfo: text(
    'One real person can help this city grow. Three contributions a day.',
    '一个真实玩家，也能推动城市成长。每日可贡献三次。',
    '一個真實玩家，也能推動城市成長。每日可貢獻三次。',
    'Una sola persona puede ayudar. Tres aportaciones al día.',
  ),
  contribute: text(
    'Lend a hand · 8 energy',
    '出一份力 · 8 精力',
    '出一份力 · 8 精力',
    'Ayudar · 8 de energía',
  ),
  caretaker: text(
    'A city that keeps going',
    '城市，始终运转',
    '城市，始終運轉',
    'Una ciudad que sigue adelante',
  ),
  caretakerInfo: text(
    'Public services run on published caretaker rules while the community grows. NPCs never cast votes.',
    '社区成长期间，公共服务按公开的托管规则运行。NPC 不会投票。',
    '社區成長期間，公共服務按公開的託管規則運行。NPC 不會投票。',
    'Los servicios funcionan con reglas públicas mientras crece la comunidad. Los NPC no votan.',
  ),
  tax: text('Commercial tax', '商业税', '商業稅', 'Impuesto comercial'),
  uiLanguage: text('Interface language', '界面语言', '介面語言', 'Idioma de la interfaz'),
  readingLanguage: text(
    'Read posts & chat in',
    '帖子与聊天的阅读语言',
    '貼文與聊天的閱讀語言',
    'Leer publicaciones y chat en',
  ),
  translationNote: text(
    'Messages can be translated into your reading language. Original text is always available.',
    '消息可以翻译成你的阅读语言；始终保留原文入口。',
    '訊息可以翻譯成你的閱讀語言；始終保留原文入口。',
    'Los mensajes pueden traducirse a tu idioma de lectura. El original siempre está disponible.',
  ),
  appearance: text('Your signature color', '你的标志色', '你的標誌色', 'Tu color personal'),
  signOut: text('Sign out', '退出登录', '登出', 'Cerrar sesión'),
  photo: text('Share your story', '分享你的故事', '分享你的故事', 'Comparte tu historia'),
  zoomIn: text('Zoom in', '放大', '放大', 'Acercar'),
  zoomOut: text('Zoom out', '缩小', '縮小', 'Alejar'),
  notReady: text(
    'Visit this place to continue',
    '前往对应地点继续',
    '前往對應地點繼續',
    'Visita este lugar para continuar',
  ),
};
export type Word = keyof typeof words;
export const translate = (locale: Locale, key: Word) => words[key][locale];
export const languageNames: Record<Locale, string> = {
  en: 'English',
  'zh-Hans': '简体中文',
  'zh-Hant': '繁體中文',
  es: 'Español',
};
export function initialLocale(): Locale {
  const saved = localStorage.getItem('ado-locale');
  return saved && saved in languageNames
    ? (saved as Locale)
    : navigator.language.startsWith('zh')
      ? navigator.language.includes('TW') || navigator.language.includes('HK')
        ? 'zh-Hant'
        : 'zh-Hans'
      : navigator.language.startsWith('es')
        ? 'es'
        : 'en';
}
export const errorText = (locale: Locale, error: unknown) => {
  const e = error as { code?: string; message?: string };
  return e.code && localizedErrors[e.code]
    ? localizedErrors[e.code][locale]
    : locale === 'en' && e.message
      ? e.message
      : words.error[locale];
};
